import axios from "axios";

// const getAuthHeaders = () => {
//   const accessToken = localStorage.getItem("access_token");
//   const signature = localStorage.getItem("signature");
//   const sua_id = localStorage.getItem("sua_id");
//   return {
//     access_token: accessToken,
//     sign: signature,
//     sua_id: sua_id,
//   };
// };

// export const connectApi = ({ method = "GET", url, payload }) => {
//   const isFormData = payload instanceof FormData;

//   return axios({
//     method,
//     url,
//     data: payload,
//     headers: {
//       ...getAuthHeaders(),
//       ...(isFormData && { "Content-Type": "multipart/form-data" }), // ✅ only if FormData
//     },
//     responseType: "json",
//   });
// };
const getAuthPayload = () => ({
  access_token: localStorage.getItem("access_token"),
  sign: localStorage.getItem("signature"),
  sua_id: localStorage.getItem("sua_id"),
});

export const connectApi = ({ method = "GET", url, payload = {} }) => {
  const isFormData = payload instanceof FormData;
  const authPayload = getAuthPayload();

  let finalUrl = url;
  let finalPayload;

  if (method.toUpperCase() === "GET") {
    // 🔑 GET 時放 querystring
    const params = new URLSearchParams({
      ...payload,
      ...authPayload,
    });
    finalUrl += (url.includes("?") ? "&" : "?") + params.toString();
    finalPayload = undefined; // GET 不需要 data
  } else {
    // POST/PUT... 才用 body
    if (isFormData) {
      finalPayload = payload;
      Object.entries(authPayload).forEach(([key, value]) => {
        if (value != null) finalPayload.append(key, value);
      });
    } else {
      finalPayload = {
        ...payload,
        ...authPayload,
      };
    }
  }

  return axios({
    method,
    url: finalUrl,
    data: finalPayload,
    headers: {
      ...(isFormData && { "Content-Type": "multipart/form-data" }),
    },
    responseType: "json",
  });
};
